/* 
 *  Created by SGiri 02/14/2018
 */

import { Injectable } from '@angular/core';
import { Dashboard } from '~config/model/dashbord';
import { BI_HttpService } from '../../services/http.service';
import { ConfigConstants } from '~config/util/config.constant';

@Injectable()
export class DashboardService {

  public globalDashboards: Dashboard[];

  constructor(private http: BI_HttpService) {
  }

  public getStandardDashboards() {
    return this.http.get(ConfigConstants.ST_DASHBOARDL_URL);
  }

  public getStandardDashboardRowData(dashboardId, isKpi) {
    return this.http.get(ConfigConstants.GET_ST_DASHBOARDL_DATA_URL + dashboardId + '/' + isKpi);
  }

  public saveRowData(data) {
    return this.http.post(ConfigConstants.SAVE_ST_DASHBOARDL_DATA_URL, data);
  }

  public saveNewWidget(data) {
    return this.http.post(ConfigConstants.SAVE_NEW_WIDGET_URL, data);
  }

  public saveKpiData(data) {
    return this.http.post(ConfigConstants.SAVE_ST_DASHBOARDL_KPI_URL, data);
  }

  public saveNewKpi(data) {
    return this.http.post(ConfigConstants.SAVE_NEW_KPI_URL, data);
  }

  public getReportAndScoreCardReportIds(dashboardId: number) {
    return this.http.get(ConfigConstants.GET_KPI_REPORTS_URL + dashboardId);
  }

  public saveNewDashboard(dashboard: any) {
    return this.http.post(ConfigConstants.SAVE_NEW_DASHBOARD_URL, dashboard);
  }

  public getLocationMapping(id: number, dashboardId: number, isKpi: boolean) {
    return this.http.get(ConfigConstants.GET_LOCATION_MAPPING_URL + id + '/' + dashboardId + '/' + isKpi);
  }

  public saveReportLocationMapping(mapping: any) {
    return this.http.post(ConfigConstants.SAVE_REPORT_LOCATION_MAPPING_URL, mapping);
  }

  public saveKpiLocationMapping(mapping: any) {
    return this.http.post(ConfigConstants.SAVE_KPI_LOCATION_MAPPING_URL, mapping);
  }

  public truncateAndReload(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(ConfigConstants.DATA_DICTIONARY_URL, formData);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/services/dashboard.service.ts